import { translate } from '@fiverr-private/i18n-react';
import { stats } from '@fiverr-private/obs';
import { STATS_PREFIX } from '../../constants';

const SUB_CATEGORY = 'sub_category';
const NESTED_SUB_CATEGORY = 'nested_sub_cat';
const SUB_CATEGORIES_PREFIX = `sub_categories.${SUB_CATEGORY}`;

/**
 * Translate service's property based sub category id and nested category id
 *
 * @param {Object} config
 * @param {number} [config.subCategoryId] - The sub category id
 * @param {number} [config.nestedSubCategoryId] - The nested sub category id
 *
 * @returns {string} translated sub category or nested sub category name
 */
export const translateLeafCategory = ({ subCategoryId, nestedSubCategoryId }) => {
    if (nestedSubCategoryId && nestedSubCategoryId !== subCategoryId) {
        return translateNestedSubCategory(subCategoryId, nestedSubCategoryId);
    } else if (subCategoryId) {
        return translateSubCategory(subCategoryId);
    } else {
        stats.count(STATS_PREFIX, 'api.deliveries.sub_category.missing');
        return '';
    }
};

/**
 * Translate a sub category by id.
 *
 * @param {number} subCategoryId - Sub category id
 * @returns {string} translated sub category name
 */
export const translateSubCategory = (subCategoryId) => translate(`${buildSubCategoryKey(subCategoryId)}.name`);

/**
 * Translate a nested sub category attribute by id.
 *
 * @param {number} subCategoryId - Sub category id
 * @param {number} nestedSubCategoryId - Nested sub category id
 * @returns {string} translated nested sub category attribute
 */
export const translateNestedSubCategory = (subCategoryId, nestedSubCategoryId) =>
    translate(`${buildNestedSubCategoryKey(subCategoryId, nestedSubCategoryId)}.name`);

/**
 * @param {number} subCategoryId - Sub category id
 * @returns {string} sub category translation path
 */
const buildSubCategoryKey = (subCategoryId) => `${SUB_CATEGORIES_PREFIX}_${subCategoryId}`;

/**
 * @param {number} subCategoryId - Sub category id
 * @param {number} nestedSubCategoryId - Nested sub category id
 * @returns {string} nested sub category translation path
 */
const buildNestedSubCategoryKey = (subCategoryId, nestedSubCategoryId) =>
    `${buildSubCategoryKey(subCategoryId)}.${NESTED_SUB_CATEGORY}_${nestedSubCategoryId}`;
